import { Button, Form, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { AppImageUploader, EFileTypes } from "components";
import { DraftImage } from "./types";

type DraftImagesFormProps = {
  blockKey: string;
  drafts: DraftImage[];
  isSaving: boolean;
  onChange: (
    blockKey: string,
    draftKey: string,
    patch: Partial<DraftImage>
  ) => void;
  onRemove: (blockKey: string, draftKey: string) => void;
};

export const DraftImagesForm = ({
  blockKey,
  drafts,
  isSaving,
  onChange,
  onRemove,
}: DraftImagesFormProps) => {
  if (!drafts.length) {
    return null;
  }

  return (
    <Form layout="vertical">
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        {drafts.map((draft, index) => (
          <Space
            key={draft.key}
            align="start"
            size={16}
            wrap
            style={{ width: "100%" }}
          >
            <Form.Item
              label={`Превью ${index + 1}`}
              required
              style={{ minWidth: 320, flex: 1 }}
            >
              <AppImageUploader
                type="MEDICINE"
                entityId={draft.key}
                serviceType={EFileTypes.MEDICINE}
                value={draft.imageUrl}
                onChange={(value) =>
                  onChange(blockKey, draft.key, {
                    imageUrl: value,
                  })
                }
                cropperProps={{
                  modalTitle: "Редактировать превью",
                }}
                uploadProps={{
                  multiple: false,
                  children: "Превью",
                  listType: "picture-card",
                }}
              />
            </Form.Item>

            <Form.Item
              label={`Детальное изображение ${index + 1}`}
              required
              style={{ minWidth: 320, flex: 1 }}
            >
              <AppImageUploader
                type="MEDICINE"
                entityId={draft.key}
                serviceType={EFileTypes.MEDICINE}
                value={draft.detailImage}
                onChange={(value) =>
                  onChange(blockKey, draft.key, {
                    detailImage: value,
                  })
                }
                cropperProps={{
                  modalTitle: "Редактировать детальное изображение",
                }}
                uploadProps={{
                  multiple: false,
                  children: "Детальное изображение",
                  listType: "picture-card",
                }}
              />
            </Form.Item>

            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => onRemove(blockKey, draft.key)}
              disabled={isSaving}
              style={{ marginTop: 30 }}
            >
              Удалить
            </Button>
          </Space>
        ))}
      </Space>
    </Form>
  );
};
